"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SfilterSizeType = void 0;
var SfilterSizeType;
(function (SfilterSizeType) {
    SfilterSizeType["GROSS"] = "G";
    SfilterSizeType["SALEABLE"] = "S";
})(SfilterSizeType = exports.SfilterSizeType || (exports.SfilterSizeType = {}));
